export default __webpack_public_path__ + "static/media/content-img-3.48204896.jpg";